import React, { PropTypes } from 'react'
import classNames from 'classnames'
import styles from './style.styl'

/* A rounded card with a branded top-border color */
export default function Well(props) {
  const { children, className, themeClass, primaryColor, style, ...rest } = props
  return (
    <div {...rest}
         className={classNames(styles.Well, 'flex-column', className, themeClass)}
         style={{
           ...style,
           borderTopColor: primaryColor,
         }}>
      {children}
    </div>
  )
}
Well.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any,
  style: PropTypes.object,
  // Branding color
  primaryColor: PropTypes.string,
}
Well.defaultProps = {
  primaryColor: '#0176FF',
  style: {},
}



// WEBPACK FOOTER //
// ./node_modules/shared-web/src/components/widget/TakeoverCampaign/Well/index.js